import { Component, ComponentRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DriversStoreService } from '../../services/store/drivers-store/drivers-store.service';
import { FleetStoreService } from '../../services/store/fleet-store/fleet-store.service';
import { DetailStoreService } from '../../services/store/detail-store/detail-store.service';
import { TripStoreService } from '../../services/store/trip-store/trip-store.service';
import { SpaceTypeStoreService } from '../../services/store/spacetype-store/spacetype-store.service';
import { LosStoreService } from '../../services/store/los-store/los-store.service';
import { formatDate, statusMap } from '../../utils/date-util';
import { getAlphabet } from 'src/app/utils/utils.common';
@Component({
  selector: 'app-route-details',
  templateUrl: './route-details.component.html',
  styleUrls: ['./route-details.component.css']
})
export class RouteDetailsComponent implements OnInit, OnDestroy {
  @Input() date;
  fleets;
  filterDataList = [];
  user;
  timeZone;
  tripDetail;
  preDriverList = {};
  preLos = {};
  preSpaceTypes = {};
  driver;
  formatDate = formatDate;
  statusMap = statusMap;

  constructor(
    private fleetStore: FleetStoreService,
    private detailStore: DetailStoreService,
    private sharedDataService: SharedDataService,
    private driverStore: DriversStoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private losStore: LosStoreService,

  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;;
          this.getFleet();
          this.filterTrips();
          this.getDriverList();
          this.getSpaceTypes();
          this.getLos();
        }
      });
  }

  filterTrips() {
    this.driver = null;
    this.filterDataList = [];
    this.detailStore.state$.subscribe((data: any) => {
      this.tripDetail = data;
      if(this.tripDetail){
        if (this.tripDetail.map.key) {
          this.driver = this.getDriverDetaiil(this.tripDetail.map.key);
          this.filterDataList = this.tripDetail.list
        } else {
          this.driver = null;
          this.filterDataList = this.tripDetail.list
        }
      }

    })
  }

  getDriverDetaiil(driverId) {
    const driver = this.preDriverList[driverId]
    return driver
  }

  getDriverList() {
    this.driverStore.state$.subscribe((data) => {
      if (data) {
        this.preDriverList = data.map;
      }
    })
  }

  getFleet() {
    this.fleetStore.state$.subscribe(data => {
      if (data) {
        this.fleets = data
      }
    })
  }
  getSpaceTypes() {
    this.spaceTypeStore.state$.subscribe((res) => {
      if (res) {
        this.preSpaceTypes = res.map;
      }
    })
  }
  getLos() {
    this.losStore.state$.subscribe((res) => {
      if (res) {
        this.preLos = res.map;
      }
    })
  }


  calculateMiles() {
    let miles = 0;
    for (let item of this.filterDataList) {
      miles += item.milage;
    }
    return miles.toFixed(2);
  }

  getAlphabet(index: number): string {
    return getAlphabet(index);
  }

   currentDayShift(shifts) {
        const currentDay = moment().tz(this.timeZone).startOf("day").day();
        if (shifts) {
          let shift = shifts.find(shift => shift.day === currentDay);
          return shift;
        } else {
          return {};
        }
   }

  ngOnDestroy(): void {

  }

}
